export default __webpack_public_path__ + "static/media/Collection_Orange.edc5bc1e.svg";